import React from "react";

function OAuthLandingPage(props) {
  return <div></div>;
}

export default OAuthLandingPage;
